<template>
  <div class="warp" style="padding: 5px 15px; height: calc(100vh - 80px); overflow: auto">
    <!-- 汇总统计表格 -->
    <div>
      <div class="flx-justify-between01">
        <div style="flex: 1">{{ $t('vehicle.matter') }}</div>
        <div style="flex: 1">{{ $t('operationTips.confirmLost') }}</div>
        <div style="flex: 1">{{ $t('fixDutyFine.StolenOrRobbed') }}</div>
        <div style="flex: 1">{{ $t('fixDutyFine.Damage') }}</div>
        <div style="flex: 1">{{ $t('vehicle.complaintHandling') }}</div>
        <div style="flex: 1">{{ $t('fixDutyFine.SocialMediaUpgradeComplaint') }}</div>
        <div style="flex: 1">{{ $t('fixDutyFine.PODIrregular') }}</div>
        <div style="flex: 1">{{ $t('compensationManagement.TimeoutNotClosedLoop') }}</div>
      </div>
      <div class="flx-justify-between01">
        <div style="flex: 1">{{ $t('collectionCenter.ballot') }}</div>
        <div style="flex: 1">{{ statisticData.confirmedLost }}</div>
        <div style="flex: 1">{{ statisticData.stolenOrRobbed }}</div>
        <div style="flex: 1">{{ statisticData.damaged }}</div>
        <div style="flex: 1">{{ statisticData.complaintWorkOrderCount }}</div>
        <div style="flex: 1">{{ statisticData.platformComplaints }}</div>
        <div style="flex: 1">{{ statisticData.podIrregularities }}</div>
        <div style="flex: 1">{{ statisticData.overtimeNotClosed }}</div>
      </div>
      <div class="flx-justify-between01">
        <div style="flex: 1">{{ $t('fixDutyFine.EstimatedPenaltyAmount') }}</div>
        <div style="flex: 1">{{ statisticData.confirmedLostAmount }}</div>
        <div style="flex: 1">{{ statisticData.stolenOrRobbedAmount }}</div>
        <div style="flex: 1">{{ statisticData.damagedAmount }}</div>
        <div style="flex: 1">{{ statisticData.complaintWorkOrderAmount }}</div>
        <div style="flex: 1">{{ statisticData.platformComplaintsAmount }}</div>
        <div style="flex: 1">{{ statisticData.podIrregularitiesAmount }}</div>
        <div style="flex: 1">{{ statisticData.overtimeNotClosedAmount }}</div>
      </div>
    </div>
    <div style="margin: 15px 0">
      <el-button size="small" type="primary" @click="exportToExcel">{{ $t('newOrder.export') }}
      </el-button>
    </div>
    <!--  表格数据  -->
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      style="width: 100%"
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="60"
      />
      <el-table-column
        :label="$t('GlobalSetObj.waybillNumber')"
        align="center"
        prop="waybillNumber"
      />
      <el-table-column
        :label="$t('GlobalSetObj.ScanNumber')"
        align="center"
        prop="scanOrderNumber"
      />
      <el-table-column
        :label="$t('fixDutyFine.DefiniteType')"
        align="center"
        prop="responsibilityTypeStr"
      />
      <el-table-column
        :label="$t('fixDutyFine.DefiniteTime')"
        align="center"
        prop="responsibilityTime"
      />
      <el-table-column
        :label="$t('fixDutyFine.ResponsibleBranch')"
        align="center"
        prop="siteName"
      />
      <el-table-column :label="$t('vehicle.cargoValue')" align="center" prop="cargoValueStr" />
      <el-table-column :label="$t('collectionCenter.freight')" align="center" prop="freightStr" />
      <el-table-column :label="$t('vehicle.fine')" align="center" prop="fineStr" />
      <el-table-column
        :label="$t('vehicle.penaltyAmount')"
        align="center"
        prop="penaltyAmountStr"
      />
    </el-table>
    <div style="text-align: right">
      <el-pagination
        :current-page.sync="searchForm.pageNumber"
        :page-size.sync="searchForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 15px 0"
        @current-change="getSearch"
        @size-change="getSearch"
      />
    </div>
  </div>
</template>

<script>
import { goResourceTaskList } from '@/utils/goExportList';
import {
  detailExport,
  getLmPenaltyBillDetailPage,
  getLmPenaltyBillSummary
} from '@/api/definiteResponsibilityAndPenalty';

export default {
  props: {
    dataobj: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      searchForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          billNo: ''
        }
      },
      statisticData: {},
      tableData: [],
      total: 0
    };
  },
  mounted() {
    this.getSummary();
    this.getSearch();
  },
  methods: {
    // 获取汇总数据
    getSummary() {
      getLmPenaltyBillSummary(this.dataobj.billNo).then((res) => {
        if (res.code === 200) {
          this.statisticData = res.data;
        }
      });
    },
    getSearch() {
      const data = {
        pageNumber: this.searchForm.pageNumber,
        pageSize: this.searchForm.pageSize,
        params: {
          billNo: this.dataobj.billNo
        }
      };
      getLmPenaltyBillDetailPage(data).then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    async exportToExcel() {
      const data = {
        billNo: this.dataobj.billNo
      };
      const res = await detailExport(data);
      if (res.code === 200) {
        const toRes = await goResourceTaskList();
        if (toRes) {
          this.$emit('call-parent-method', false);
        }
      }
    },
    resetForm() {
      this.searchForm = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          billNo: ''
        }
      };
      this.getSearch();
    }
  }
};
</script>

<style scoped>
.search-form {
  margin-bottom: 20px;
}

.warp >>> .el-form-item {
  margin-bottom: 0 !important;
}

.flx-justify-between01 {
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  border-left: 1px solid #ebeef5; /* 只保留左边框 */
  border-right: 1px solid #ebeef5; /* 只保留右边框 */
  cursor: pointer;
}

.flx-justify-between01 > div {
  flex: 1;
  padding: 8px 12px;
  border-right: 1px solid #ebeef5; /* 单元格右侧边框 */
  border-bottom: 1px solid #ebeef5; /* 单元格底部边框 */
  text-align: center;
}

/* 移除最后一个子元素的右侧边框 */
.flx-justify-between01 > div:last-child {
  border-right: none;
}

/* 表头样式（第一个容器）增加顶部边框 */
.flx-justify-between01:first-child {
  border-top: 1px solid #ebeef5; /* 补充顶部边框 */
  background-color: #f2f2f2;
  font-weight: 600;
  color: #303133;
}
</style>
